import { Model } from '../decorators/model.decorator';
import { Column } from '../decorators/column.decorator';
import { BaseModel } from './base.model';
import { VdmoServer } from './vdmo_server.model'

@Model('accountVdmoServer')
export class AccountVdmoServer extends BaseModel {
  @Column()
  email: string | undefined

  @Column()
  vdmoServer: VdmoServer | undefined;
}
